// extracted by mini-css-extract-plugin
export default {"productStack":"Product_productStack__j16tW","title":"Product_title__Odl22","featureBottomBox":"Product_featureBottomBox__MTKQx","subFeatureBox":"Product_subFeatureBox__lFzXY"};